import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { IGetRecentProfessionalsParams } from '../recentProfessionalsApi';
import { recentProfessionalsService } from '../recentProfessionalsService';
import { IRecentProfessional } from '../recentProfessionalsTypes';

type TUseRecentProfessionalsParams = IGetRecentProfessionalsParams & {
  enabled: boolean;
};

export function useRecentProfessionals(params: TUseRecentProfessionalsParams) {
  const dispatch = useDispatch();
  const query = useQuery<IRecentProfessional[]>({
    queryKey: ['recent-professionals', params],
    queryFn: () => recentProfessionalsService.getRecentProfessionals(params),
    enabled: params.enabled,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      dispatch({ type: 'SET_RECENT_PROFESSIONALS', payload: query.data });
    }
  }, [query.data, dispatch]);

  return {
    ...query,
  };
}
